import { IkeToken } from '@ikegps/core-api';
import { T } from '../../i18n';
import { Services } from '../../services/index';
import { CurrentState } from '../../state/page.state';
import { UserAssignModal } from '../user.assign.modal/user.assign.modal';

export const CollectionAssignCtrl = {
	canAssign(): boolean {
		return (
			Services.Token.has(IkeToken.FEATURE_COLLECTION_ASSIGN) || Services.Token.has(IkeToken.FEATURE_GROUP_IKE_ANALYZE)
		);
	},

	showAssignModal(): void {
		const collections = CurrentState.Tag.collections;
		const confirmModal = new UserAssignModal(
			{
				title: T.COLLECTION_ASSIGN_TITLE,
				confirm: T.COLLECTION_ASSIGN,
				success: {
					key: T.COLLECTION_ASSIGN_SUCCESS,
					attrs: {
						count: collections.length,
					},
				},
			},
			collections
		);

		confirmModal.open();
	},
};
